import { render, staticRenderFns } from "./sections.vue?vue&type=template&id=51b712b8&scoped=true&"
import script from "./sections.vue?vue&type=script&lang=ts&"
export * from "./sections.vue?vue&type=script&lang=ts&"
import style0 from "./sections.vue?vue&type=style&index=0&id=51b712b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b712b8",
  null
  
)

export default component.exports